import loadable from '@loadable/component';

/* istanbul ignore next */
export const PurchaseTermsModalLoadable = loadable(() => import('./PurchaseTermsModal'), {
  resolveComponent: ({ PurchaseTermsModalContainer }) => PurchaseTermsModalContainer,
});
